<template>
  <v-container fluid>
    <div style="overflow: auto">
      <v-card min-width="1000px" min-height="91vh">
        <v-card-title class="pt-0 flex flex-nowrap align-center">
          <div class="header-left-sidebar">
            <h2>Timesheet</h2>
            <div class="header-date-total-block">
              <div class="header-date-block">
                <v-btn
                  icon
                  small
                  @click="changeMonth(-1)"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <div>
                  <div class="header-date">
                    {{ selectedDate | changeFormat('MMMM YYYY') }}
                  </div>
                  <div
                    v-if="totalReportsOfSelectedMonth"
                    class="this-month-total"
                  >
                    <span>Reported: </span>
                    <span
                      class="pr-3"
                    >
                    <b>{{ totalReportsOfSelectedMonth.Reports | roundToTenth }}</b>
                  </span>
                    <span>Paid: </span>
                    <span
                      :class="{
                      'highlight-text': totalReportsOfSelectedMonth.Reports !== totalReportsOfSelectedMonth.Paid_Reports
                    }"
                    >
                    <b>{{ totalReportsOfSelectedMonth.Paid_Reports | roundToTenth }}</b>
                  </span>
                  </div>
                </div>
                <v-btn
                  icon
                  small
                  @click="changeMonth(1)"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </div>
            <v-btn
              small
              color="primary"
              @click="changeMonth()"
            >
              Today
            </v-btn>
            <v-tooltip bottom color="grey lighten-1">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  small
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="refreshReports"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </div>
          <v-spacer></v-spacer>
          <div
            v-if="totalReportsOfThisMonth"
            class="header-report-block"
          >
            <div class="report-section">
              <span>{{ totalReportsOfThisMonth.Label }}</span>
            </div>
            <div class="report-section">
              <span>Reported: </span>
              <span
                class="pr-3"
              >
                <b>{{ totalReportsOfThisMonth.Reports | roundToTenth }}</b>
              </span>
              <span>Paid: </span>
              <span
                :class="{
                'highlight-text': totalReportsOfThisMonth.Reports !== totalReportsOfThisMonth.Paid_Reports
                }"
              >
                <b>{{ totalReportsOfThisMonth.Paid_Reports | roundToTenth }}</b>
              </span>
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="weekdays">
            <div
              :class="{
          holiday: calendarHeader === 'Saturday' || calendarHeader === 'Sunday'
        }"
              v-for="calendarHeader in calendarHeaders"
              :key="calendarHeader"
            >
              {{ calendarHeader }}
            </div>
            <div class="total-of-week-header">
              Week Total
            </div>
          </div>
          <div>
            <div v-for="(week, weekIndex) in weeks" :key="weekIndex" class="week">
              <div
                v-for="(day, dayIndex) in week" :key="dayIndex"
                @click="openDayDetail(weekIndex, day)"
                :class="{
                 day: true,
                 'day-outside' : !isSameMonth(day.Start_Date),
                 holiday: isHoliday(day.Start_Date),
                 'is-active-day': isSameAsActiveDay(day.Start_Date),
                 today: isToday(day.Start_Date)
               }"
              >
                <div class="day-plus-container">
                  <v-btn
                    icon
                    small
                    color="success"
                    class="day-plus-btn"
                    @click.stop="showAddReport(day)"
                  >
                    <v-icon>mdi-plus-circle</v-icon>
                  </v-btn>
                </div>
                <div v-if="day.Vacation_Hours > 0"
                  class="vacation-mark"
                  :title="'Vacation or Sick-leave'"
                  ></div>
                <span
                  :class="{
              'day-reports': true,
              'highlight-text': day.Reports !== day.Paid_Reports
            }"
                >
              {{ day.Reports | roundToTenth }}
            </span>
                <span class="date-of-day">
              {{ day.Start_Date | dateFormat }}
            </span>
              </div>
              <div
                :class="{
            'total-of-week': true,
            'highlight-text' : genTotalWeek(week).notEqualReports
          }"
              >
                {{ genTotalWeek(week).totalReports | roundToTenth }}
              </div>
              <div
                class="drop-down-table-bock details-box"
                v-if="weekIndex === clickedWeekIndex && isActiveDayInCalendarRange"
              >
                <v-data-table
                  :headers="headers"
                  :items="dayReports"
                  hide-default-footer
                  class="elevation-1"
                  :mobile-breakpoint="0"
                  :loading="loadingDayReports"
                  loading-text="Loading..."
                >
                  <template v-slot:item.Paid_Reports="{ item }">
                    <div :class="{ 'highlight-text': item.Paid_Reports !== item.Reports }">
                      {{ item.Paid_Reports }}
                    </div>
                  </template>
                  <template v-slot:item.Description="{ item }">
                    <div class="description-cell">
                      <v-tooltip
                        offset-overflow
                        open-delay="150"
                        color="#424852"
                        bottom
                        max-width="400px"
                      >
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            {{ item.Description }}
                          </div>
                        </template>
                        <span class="tooltip-content">{{ item.Description }}</span>
                      </v-tooltip>
                    </div>
                  </template>
                  <template v-slot:[`item.Actions`]="{ item , index }">
                    <v-tooltip
                      bottom
                      :color="item.Status === 'C' ? 'grey lighten-1' : 'primary'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" class="d-inline-block">
                          <v-btn
                            :disabled="item.Status === 'C'"
                            icon
                            color="primary"
                            @click="showUpdateReport(item)"
                          >
                            <v-icon>mdi-pencil-circle</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span v-if="item.Status === 'C'">Closed</span>
                      <span v-else>Edit</span>
                    </v-tooltip>
                    <v-tooltip
                      bottom
                      :color="item.Status === 'C' ? 'grey lighten-1' : 'red darken-2'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" class="d-inline-block">
                          <v-btn
                            :disabled="item.Status === 'C'"
                            icon
                            color="red darken-2"
                            @click="showDeleteReport(item, index)"
                          >
                            <v-icon>mdi-delete-circle</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span v-if="item.Status === 'C'">Closed</span>
                      <span v-else>Delete</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </v-card-text>
        <ConfirmOrDeniedDialog
          v-if="showDeleteReportDialog"
          v-model="showDeleteReportDialog"
          :mode="confirmOrDeniedDialogModes.delete"
          @onDeleteClick="deleteReport"
          @onCancelClick="cancelDeleting"
          @onCloseClick="cancelDeleting"
        />
        <ManageReportingDialog
          v-if="showManageReportingDialog"
          v-model="showManageReportingDialog"
          :mode="manageReportingMode"
          :report="manageReport"
          @reportUpdate="reloadReports"
        />
      </v-card>
    </div>
  </v-container>
</template>

<script>
import moment from 'moment'
import { getApiErrorMessage } from '@/utils/apiError'
import { safeParseLocalStorage } from '@/utils/storageUtils'

export default {
  name: 'Reporting',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue'),
    ManageReportingDialog: () => import('@/components/reporting/ManageReportingDialog.vue')
  },
  data () {
    return {
      activeDay: null,
      clickedWeekIndex: null,
      calendarHeaders: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      calendar: [],
      dayReports: [],
      firstDayOfMonth: null,
      firstOffsetDayOfMonth: null,
      reportIDToDelete: null,
      reportIndexToDelete: null,
      selectedDate: safeParseLocalStorage('reportingNew')?.CurrentMonth || moment().format('YYYY-MM-DD'),
      showDeleteReportDialog: false,
      showManageReportingDialog: false,
      lastDayOfMonth: null,
      lastOffsetDayOfMonth: null,
      loadingDayReports: false,
      manageReport: null,
      manageReportingMode: null,
      today: moment().format('YYYY-MM-DD'),
      totalReportsOfSelectedMonth: null,
      totalReportsOfThisMonth: null,
      headers: [
        {
          text: 'Project',
          value: 'Project_Name',
          sortable: false,
          class: 'px-2 text-no-wrap font-weight-medium text--primary subtitle-2',
          cellClass: 'px-2 text-no-wrap',
          width: '15%'
        },
        {
          text: 'Task',
          value: 'Task_Name',
          sortable: false,
          class: 'px-2 text-no-wrap font-weight-medium text--primary subtitle-2',
          cellClass: 'px-2 text-no-wrap',
          width: '15%'
        },
        {
          text: 'Est./Rep.',
          value: 'EstRep',
          sortable: false,
          class: 'px-2 text-no-wrap font-weight-medium text--primary subtitle-2',
          cellClass: 'px-2 text-no-wrap',
          width: '10%'
        },
        {
          text: 'Reported',
          value: 'Reports',
          align: 'center',
          sortable: false,
          class: 'px-2 text-no-wrap font-weight-medium text--primary subtitle-2',
          cellClass: 'px-2 text-no-wrap font-weight-bold text--primary',
          width: '10%'
        },
        {
          text: 'Paid',
          value: 'Paid_Reports',
          align: 'center',
          sortable: false,
          class: 'px-2 text-no-wrap font-weight-medium text--primary subtitle-2',
          cellClass: 'px-2 text-no-wrap font-weight-bold text--primary',
          width: '10%'
        },
        {
          text: 'Activity',
          value: 'Activity_Description',
          sortable: false,
          class: 'px-2 text-no-wrap font-weight-medium text--primary subtitle-2',
          cellClass: 'px-2 text-no-wrap',
          width: '10%'
        },
        {
          text: 'Description',
          value: 'Description',
          sortable: false,
          class: 'px-2 text-no-wrap font-weight-medium text--primary subtitle-2',
          cellClass: 'px-2',
          width: '20%'
        },
        {
          text: '#',
          value: 'Actions',
          sortable: false,
          align: 'center',
          width: '10%',
          class: 'px-2 text-no-wrap font-weight-medium text--primary subtitle-2',
          cellClass: 'px-2 text-no-wrap'
        }
      ]
    }
  },

  mounted () {
    this.genStartEndOfMonth(this.selectedDate)
    this.getTotalDaysReports()
  },
  computed: {
    settings () {
      return this.$store.getters.getSettings
    },
    user () {
      return this.$store.getters.getUser
    },
    weeks () {
      return this.calendar
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    isActiveDayInCalendarRange () {
      return this.activeDay && moment(this.activeDay.Start_Date).isBetween(this.firstOffsetDayOfMonth, this.lastOffsetDayOfMonth, 'day', '[]')
    }
  },
  filters: {
    roundToTenth (val) {
      if (Number.isInteger(val)) {
        return val
      } else {
        return Math.round(val * 10) / 10
      }
    },
    changeFormat (date, format) {
      return moment(date).format(format)
    },
    dateFormat (val) {
      return moment(val).date()
    }
  },
  methods: {
    isSameMonth (date) {
      return moment(this.selectedDate).isSame(moment(date), 'month')
    },

    isHoliday (date) {
      return moment(date).format('dddd') === 'Saturday' || moment(date).format('dddd') === 'Sunday'
    },

    isSameAsActiveDay (date) {
      return this.activeDay && moment(this.activeDay.Start_Date).isSame(moment(date), 'day')
    },

    isToday (date) {
      return moment(this.today).isSame(moment(date), 'day')
    },

    genStartEndOfMonth (date) {
      this.firstDayOfMonth = moment(date).startOf('month').format('YYYY-MM-DD')
      this.firstOffsetDayOfMonth = moment(date).startOf('month').startOf('isoWeek').format('YYYY-MM-DD')
      this.lastDayOfMonth = moment(date).endOf('month').format('YYYY-MM-DD')
      this.lastOffsetDayOfMonth = moment(date).endOf('month').endOf('isoWeek').format('YYYY-MM-DD')
    },

    genTotalWeek (week) {
      const {
        totalReports,
        totalPaidReports
      } = week.reduce((acc, next) => {
        acc.totalReports += next.Reports
        acc.totalPaidReports += next.Paid_Reports
        return acc
      }, {
        totalReports: 0,
        totalPaidReports: 0
      })
      const notEqualReports = totalReports !== totalPaidReports
      return {
        totalReports,
        notEqualReports
      }
    },

    genTotalMonth (reports) {
      const totalMonthReports = reports.reduce((acc, next) => {
        if (moment(next.Start_Date).isBetween(this.firstDayOfMonth, this.lastDayOfMonth, 'day', '[]')) {
          acc.Reports += next.Reports
          acc.Paid_Reports += next.Paid_Reports
        }
        return acc
      }, {
        Reports: 0,
        Paid_Reports: 0
      })
      this.totalReportsOfSelectedMonth = {
        ...totalMonthReports,
        Label: 'This Month'
      }
      if (moment(this.today).isSame(this.selectedDate, 'month')) {
        this.totalReportsOfThisMonth = {
          ...totalMonthReports,
          Label: 'Current Month'
        }
      } else if (!this.totalReportsOfThisMonth) {
        this.getTotalCurrentMonthReports()
      }
    },

    genCalendar (reports) {
      const dateRange = moment(this.lastOffsetDayOfMonth).diff(moment(this.firstOffsetDayOfMonth), 'days') + 1
      const firstDayToMomentObj = moment(this.firstOffsetDayOfMonth)
      const calendar = []

      for (let i = 0; i < dateRange; i++) {
        calendar.push(firstDayToMomentObj.format('YYYY-MM-DD'))
        firstDayToMomentObj.add(1, 'day')
      }
      const mergeOfCalAndRep = calendar.map(date => {
        const report = reports.find(r => r.Start_Date === date)
        return report || {
          Start_Date: date,
          Paid_Reports: 0,
          Reports: 0,
          Vacation_Hours: 0
        }
      })
      const weeksCalendar = []

      for (let i = 0; i < mergeOfCalAndRep.length; i += 7) {
        weeksCalendar.push(mergeOfCalAndRep.slice(i, i + 7))
      }
      this.calendar = weeksCalendar
    },

    async changeMonth (step) {
      if (step) {
        this.selectedDate = moment(this.selectedDate).add(step, 'month').format('YYYY-MM-DD')
      } else {
        this.today = moment().format('YYYY-MM-DD')
        this.selectedDate = moment(this.today).format('YYYY-MM-DD')
      }

      localStorage.setItem('reportingNew', JSON.stringify({ CurrentMonth: this.selectedDate }))

      this.genStartEndOfMonth(this.selectedDate)
      await this.getTotalDaysReports()

      if (this.activeDay && this.isActiveDayInCalendarRange) {
        const weekIndexToOpen = this.findActiveWeekIndex(this.activeDay.Start_Date)
        this.openDayDetail(weekIndexToOpen, this.activeDay, false, false)
      }
    },

    findActiveWeekIndex (day) {
      for (let i = 0; i < this.calendar.length; i++) {
        for (let j = 0; j < this.calendar[i].length; j++) {
          if (moment(this.calendar[i][j].Start_Date).isSame(day)) {
            return i
          }
        }
      }
    },

    openDayDetail (weekIndex, day, close = true, clearReports = true) {
      if (this.isSameAsActiveDay(day.Start_Date) && close) {
        this.clickedWeekIndex = null
        this.activeDay = null
        this.dayReports = []
        return
      }

      this.activeDay = day
      this.clickedWeekIndex = weekIndex

      if (clearReports) {
        this.dayReports = []
        this.getDayReports()
      }
    },

    showDeleteReport (item, index) {
      this.showDeleteReportDialog = true
      this.reportIDToDelete = item.Reporting_ID
      this.reportIndexToDelete = index
    },

    cancelDeleting () {
      this.showDeleteReportDialog = false
      this.reportIDToDelete = null
      this.reportIndexToDelete = null
    },

    showUpdateReport (item) {
      this.manageReport = item
      this.manageReportingMode = 'update'
      this.showManageReportingDialog = true
    },
    showAddReport (day) {
      this.showManageReportingDialog = true
      this.manageReportingMode = 'create'
      this.manageReport = {
        Reporting_ID: null,
        Start_Date: day.Start_Date,
        Start_Time: '00:00',
        Paid_Reports: 0,
        Reports: 0,
        Invoice_Dur: null,
        Description: null,
        Activity_Type: this.settings.defaultActivityType
      }
    },
    reloadReports (selectedDateInPopup) {
      this.getTotalDaysReports()
      if (this.manageReportingMode === 'update' || (this.manageReportingMode === 'create' && this.activeDay && this.activeDay.Start_Date === selectedDateInPopup)) {
        this.openDayDetail(this.clickedWeekIndex, this.activeDay, false)
      }
      this.showManageReportingDialog = false
    },
    refreshReports () {
      this.getTotalDaysReports()
      if (this.activeDay && this.isActiveDayInCalendarRange) {
        this.openDayDetail(this.clickedWeekIndex, this.activeDay, false)
      }
    },
    async getTotalDaysReports () {
      await this.axios.get(`/api/total_days_reports/${this.firstOffsetDayOfMonth}/${this.lastOffsetDayOfMonth}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.genCalendar(res.data)
        this.genTotalMonth(res.data)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },

    getDayReports () {
      this.loadingDayReports = true
      this.axios.get(`/api/day_reports/${this.activeDay.Start_Date}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.dayReports = response.data
        this.loadingDayReports = false
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getTotalCurrentMonthReports () {
      const firstDayOfThisMonth = moment(this.today).startOf('month').format('YYYY-MM-DD')
      const lastDayOfThisMonth = moment(this.today).endOf('month').format('YYYY-MM-DD')

      this.axios.get(`/api/total_month_reports/${firstDayOfThisMonth}/${lastDayOfThisMonth}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.totalReportsOfThisMonth = {
          ...response.data[0],
          Label: 'Current Month'
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    deleteReport () {
      this.axios.delete(`/api/day_reports/${this.reportIDToDelete}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        if (response.data[0].AffectedRows === 0) {
          const errorMsg = getApiErrorMessage(new Error('Something went wrong'))
          this.$store.dispatch('setError', { errorMsg })
          return
        }
        this.dayReports.splice(this.reportIndexToDelete, 1)
        this.getTotalDaysReports()
        this.$store.dispatch('setSuccess', { successMsg: 'Report successfully deleted' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-left-sidebar {
  min-width: 580px;
  justify-content: space-between;
  display: flex;
  align-items: center;

  .header-date-total-block {
    display: flex;
    align-items: center;
  }
}

.header-date-block {
  width: 270px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-date {
    color: #6D6D6D;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
  }
}

.this-month-total {
  font-size: 14px;
  line-height: normal;
  font-weight: normal;
}

.header-report-block {
  display: flex;
  font-size: 14px;
  flex-direction: column;
  justify-content: flex-end;
}

.report-section {
  text-align: right;
  line-height: normal;
  font-weight: normal;
}

.weekdays {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  background-color: rgba(0, 0, 0, 0.02);

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border: 1px solid #ccc;
    height: 30px;
    font-size: 16px;
    font-weight: 500;
    color: #a5a5a5;
  }

  .total-of-week-header {
    background-color: rgba(0, 0, 0, 0.04);
  }
}

.week {
  display: grid;
  grid-template-columns: repeat(8, 1fr);

  .total-of-week {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 500;
    border: 1px solid #CCCCCC;
    background-color: rgba(0, 0, 0, 0.04);
    color: var(--v-customTextColor-base);
  }

  .day-outside {
    color: #AAAAAA;
    background-color: rgba(0, 0, 0, 0.02);
  }
}

.day {
  display: flex;
  position: relative;
  border: 1px solid #ccc;
  aspect-ratio: 1 / 0.5;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  color: var(--v-customTextColor-base);
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.02);

  &:hover {
    border: 2px solid #1976d2;
    .day-plus-btn {
      display: block !important;
    }
  }
}

.is-active-day {
  border: 2px solid #1976d2;
}

.vacation-mark {
  position: absolute;
  right: 4px;
  bottom: 4px;
  width: 12px;
  height: 12px;
  background-color: rgb(76, 175, 80);
  border-radius: 1px;
  z-index: 1;
}

.date-of-day {
  align-self: flex-start;
  padding: 4px;
  font-weight: normal;
  color: #a5a5a5;
  font-size: 16px;
}

.day-reports {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-weight: 500;
  font-size: 24px;
}

.day-plus-container {
  align-self: flex-end;

  .day-plus-btn {
    display: none;
  }
}

.highlight-text {
  color: #BB2A2A !important;
}

.theme--light .holiday {
  background-color: #FFF8E8;
}

.theme--dark .holiday {
  background-color: darken(#1cc26f, 30%);
}

:deep(.theme--light) .today {
  background-color: darken(#EDF6FC, 10%);
}

:deep(.theme--dark) .today {
  background-color: #1565C0;
}

.details-box {
  border: 1px solid #ccc;
  border-radius: 8px;
}

:deep(.theme--dark) .details-box {
  border-color: rgba(255, 255, 255, 0.2);
}
.description-cell {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 3em;
}

.tooltip-content {
  font-size: 14px;
  white-space: pre-wrap;
}

.drop-down-table-bock {
  grid-column: span 8;
}
</style>
